import React, { createContext, useContext, useState } from 'react';
import { Event } from '@/types';

interface EventContextType {
  currentEvent: Event | null;
  setCurrentEvent: (event: Event | null) => void;
}

const EventContext = createContext<EventContextType | undefined>(undefined);

export function useEvent() {
  const context = useContext(EventContext);
  if (context === undefined) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  return context;
}

export function EventProvider({ children }: { children: React.ReactNode }) {
  const [currentEvent, setCurrentEvent] = useState<Event | null>(null);

  const value: EventContextType = {
    currentEvent,
    setCurrentEvent,
  };

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
}

